import _BaseAPIService from "../_BaseAPIService";

const instance = _BaseAPIService.instance;

const TasksData = {
    gettask:async() => {
        try{
            const response = await instance.get("/tasks");
            console.log("Tasks data response",response.data);
            return response.data;
        }catch(error){
            console.log("Error fetching the tasks info",error);
            throw error;
        }
    },
};

export default TasksData;